import React, { Component } from "react";
import Slider from "react-slick";

export default class partner extends Component {
    render() {
        const settings = {
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            speed: 2000,
            autoplaySpeed: 2000,
            // cssEase: "linear",
            arrows: false,
            initialSlide: 0,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (

            <section className="section-padding partners partners-bg">
                <h2 className="hidden">همکاران</h2>
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <Slider {...settings}>
                                <div className="partners-slider">
                                    <div className="grid">
                                        <img src="assets/images/partners/img-1.png" alt='' role='presentation' />
                                    </div>
                                </div>

                                <div className="partners-slider">
                                    <div className="grid">
                                        <img src="assets/images/partners/img-2.png" alt='' role='presentation' />
                                    </div>
                                </div>


                                <div className="partners-slider">
                                    <div className="grid">
                                        <img src="assets/images/partners/img-3.png" alt='' role='presentation' />
                                    </div>
                                </div>


                                <div className="partners-slider">
                                    <div className="grid">
                                        <img src="assets/images/partners/img-4.png" alt='' role='presentation' />
                                    </div>
                                </div>


                                <div className="partners-slider">
                                    <div className="grid">
                                        <img src="assets/images/partners/img-5.png" alt='' role='presentation' />
                                    </div>
                                </div>

                                <div className="partners-slider">
                                    <div className="grid">
                                        <img src="assets/images/partners/img-6.png" alt='' role='presentation' />
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>

        );
    }
}